import { computed } from 'vue'
import { useStore } from 'vuex'

// 用于方便地访问Vuex数据
export function useSelector(fn) {
	const store = useStore()
	// Vuex数据要用computed包裹，处理响应式问题
	return computed(() => fn(store.state))
}

// 用于派发actions的
export function useDispatch() {
	const store = useStore()
	return store.dispatch
}

//获取全局数据
export function useGlobal(key) {
	return getCurrentInstance().appContext.config.globalProperties[key]
}

// 获取assets静态资源
export function getAssetsFile(fileName, url) {
	return new URL(`../assets/${fileName}/${url}`, import.meta.url).href
}
